import { Button, ColorsEnum, Text } from '@shared/widgets';

interface ItemProps {
  name: React.ReactNode;
  value: React.ReactNode;
  icon: React.ReactNode;
}

export const ModalItem = (props: ItemProps) => {
  const handleCopy = async () => {
    const paymentDetails = ` ${props.value}`;
    await navigator.clipboard.writeText(paymentDetails);
  };

  return (
    <div className='flex items-center justify-between'>
      <div>
        <Text size='sm' color={ColorsEnum.Secondary}>
          {props.name}
        </Text>
        <Text weight='semibold' size='sm'>
          {props.value}
        </Text>
      </div>
      <Button className='p-2' color='icon' onClick={handleCopy}>
        {props.icon}
      </Button>
    </div>
  );
};
